import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {MAIN_COLOR, SUCCESS_COLOR} from "@view/constants/colors";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";


const sx = {
    button: {

        textTransform: 'inherit',
       'lightTheme &':{
           color: MAIN_COLOR,
           backgroundColor: '#fff',
           '&:hover': {
               backgroundColor: '#fff',
           }
       }
    },
}
const ButtonSidebar = ({
                           label,
                           disabled=false,
                           icon = undefined,
                           onClick = undefined,
                           fullWidth = false,
                           color = SUCCESS_COLOR, sx: sxProps = {}, ...rest
                       }) => {
    return (
        <ButtonCustom
            {...rest}
            onClick={onClick}
            fullWidth={fullWidth}
            disabled={disabled}
            component={'div'}
            sx={{
                ...sx.button,
                ...sxProps
            }}
            endIcon={<IconButtonCustom
                disabled={disabled}
                component={'div'}
                color={color}
            >
                {icon}
            </IconButtonCustom>}
            variant={'contained'}
            label={label}
        />
    )
}

export default ButtonSidebar;